import moment from "moment-timezone";

import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { GET_AVAILABLE_PAY_REQUEST_DATES } from "src/api-setup/api-endpoints";
import { API_CONSTANTS } from "../../providerPayRequestDashboard/utils/constants";
import { getEndOfMonthInServerTz, getStartOfMonthInServerTz } from "../utils/dateRangeHelper";

/*
 * Dates in the given month that still have capacity under this contract.
 * Anything absent from the response is disabled on the calendar.
 */
export const getAvailablePayRequestDates = async (
  cookiesData,
  dispatch,
  { providerId, locationMstrKey, contractMstrKey, monthDate }
) => {
  if (!cookiesData || !providerId || !locationMstrKey || !contractMstrKey) return [];

  try {
    const apiHeaders = generateHeader();
    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_provider_id: providerId,
      in_location_mstr_key: locationMstrKey,
      in_contract_mstr_key: contractMstrKey,
      in_device_local_tz: moment.tz.guess(),
      in_start_date: getStartOfMonthInServerTz(monthDate),
      in_end_date: getEndOfMonthInServerTz(monthDate),
      in_sort_number: API_CONSTANTS.DEFAULT_SORT_NUMBER,
      in_sort_order: API_CONSTANTS.DEFAULT_SORT_ORDER_ASC,
    };

    const response = await POSTAPI(
      false,
      GET_AVAILABLE_PAY_REQUEST_DATES,
      null,
      apiHeaders,
      requestBody,
      dispatch
    );
    const rowResult = response?.data?.row_result;

    return Array.isArray(rowResult) ? rowResult : [];
  } catch (error) {
    console.error("Error fetching available pay request dates:", error);
    return [];
  }
};
